module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kansai-1-9a16824dcfecfa2984d5a1287aec16f9.png";